import './TextArea-54099020.css';

var classes = {"TextArea":"prc-Textarea-TextArea-13q4j"};

export { classes as default };
